import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Label, Icon } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Local Selectors
import { makeSelectMyTimesheetEntriesWeekTotal } from './selectors';

import './styles.scss';

interface OwnProps {}

interface ConnectedProps {
    duration: string;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntriesWeekTotal extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { duration } = this.props;

        return (
            <Label
                title={`Total duration: ${duration}`}
                className="duration-label"
                secondary
                size="large"
            >
                <Icon name="clock" />
                {duration}
            </Label>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    duration: makeSelectMyTimesheetEntriesWeekTotal()
});

export default connect(mapStateToProps)(MyTimesheetEntriesWeekTotal);
